var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetPro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_90521",
    "data-name": "Group 90521"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83263",
    "data-name": "Path 83263",
    d: "M2.084,14.2l-1.077-7a.584.584,0,0,1,.928-.556L5.29,9.16a.8.8,0,0,0,1.148-.2l2.793-4.19a.746.746,0,0,1,1.241,0l2.793,4.19a.8.8,0,0,0,1.148.2L17.77,6.644A.584.584,0,0,1,18.7,7.2l-1.077,7Z",
    transform: "translate(-1 -4.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83264",
    "data-name": "Path 83264",
    d: "M17.563,25.76H3.647a.81.81,0,0,1-.81-.81V23.171H18.373V24.95A.81.81,0,0,1,17.563,25.76Z",
    transform: "translate(-1.753 -12.118)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetPro);
export default __webpack_public_path__ + "static/media/get-pro.0d023edb1f36f44616ffef93aec4c86f.svg";
export { ForwardRef as ReactComponent };